import { useState, useCallback } from 'react';
import { shortenAddress } from '@/utils/formatting';

interface CopyableAddressProps {
  address: string;
  className?: string;
}

/**
 * Clickable address component that copies to clipboard on click.
 * Shows the shortened address and displays "✓ Copied!" feedback.
 */
export function CopyableAddress({ address, className = 'text-sm text-gray-500 hover:text-blue-600' }: CopyableAddressProps): JSX.Element {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(address);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  }, [address]);

  return (
    <button
      type="button"
      onClick={() => { void handleCopy(); }}
      className={`${className} cursor-pointer transition-colors`}
      title="Click to copy full address"
    >
      {copied ? '✓ Copied!' : shortenAddress(address)}
    </button>
  );
}
